<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>
    <loading
      :active="loading || loadingSesion"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <Header v-if="vistaCompleta" />

    <div
      class="mt-4 ml-2 mr-2 pl-4 pr-4 pt-3 text-left"
      style="background-color: white; min-height: 10vh; border-radius: 15px"
      :class="{'bordeActivo': planesActivos != null && planesActivos.length > 0}"
    >
      <div class="d-flex justify-content-between w-100">
        <div class="d-flex align-items-center" style="height: 100%;">
          <div>
            <em v-if="patInfo.esPacienteVIP" class="mr-2" v-b-tooltip.hover.top.v-light
                title="Este Paciente es MISD"
                aria-label="Paciente MISD">
              <font-awesome-icon :icon="['fas', 'crown']" size="lg" style="color: #FFD43B;" />
            </em>
          </div>
          <div>
            <em v-if="edad >= 12" class="paciente" style="width: 2.3em"></em>
            <em v-else class="paciente_nino" style="width: 2.3em"></em>
          </div>
          <div class="d-flex ml-2" id="popover-acciones">
                <p style="color: #357D97; font-weight: 600; font-size: 1.1em;">{{ patInfo.nombreCompleto }}</p>
                <a href="#" @click.prevent><em class="tres_puntos ml-2 mt-1" style="width: 1.1em" v-b-tooltip.hover.top.v-light title="Ver acciones"></em></a>
              </div>
        </div>

        <div style="width: max-content;">
          <div class="text-center mt-2"
              v-if="patInfo.ptisActivos != null && patInfo.ptisActivos.length > 0"
              style="background-color: #DBFFD8; color: #1E7C1E; border-radius: 20px; 
                      padding: 4px 10px; font-weight: 500; font-size: 1em; 
                      display: inline-block;">
            <p class="m-0 p-0">PTI activo</p>
          </div>
          <div class="w-100 text-center mt-2" v-else-if="patInfo.ptisActivos == null || patInfo.ptisActivos.length == 0">
            <p style="font-weight: 500; color: #515151; font-size: 1em">Sin PTI activo</p>
          </div>
        </div>
      </div>
      <b-popover
        target="popover-acciones"
        triggers="click blur"
        placement="rightbottom"
        auto-close
      >
        <div class="d-flex align-items-center flex-column" style="min-height: 3vh;">
          <p class="acciones" v-if="$localStorageService.can('BT_px_editar_px')" @click="abrirEditarPaciente()">Editar paciente</p>
          <p class="acciones mt-3" @click="mostrarPacientesRelacionados()">Ver parentescos</p>
          <p class="acciones mt-3" v-if="$localStorageService.can('BT_px_vip')" @click="marcarPacienteVIP()">{{ !patInfo.esPacienteVIP ? " Marcar como MISD " : " Quitar MISD" }}</p>
        </div>
      </b-popover>
      
      <b-row style="margin-bottom: 1.8% !important; margin-top: 1.6%;">
        <b-col class="ml-2" style="position: relative">
          <div class="borde-derecho"></div>
            <p>
              <span class="txt_info">Edad:</span> {{ patInfo.fechaNacimientoCompleta }}
            </p>
            <p>
              <span class="txt_info">ID:</span> {{ patInfo.idPaciente }}
            </p>
            <p>
              <span class="txt_info"> Sexo:</span>
                {{
                  patInfo.idSexo == 1
                  ? "Masculino"
                  : patInfo.idSexo == 2
                  ? "Femenino"
                  : "No responder"
                }}
            </p>
            <p v-if="patInfo.fechaProximaCita != null"><span class="txt_info">Próxima cita:</span>{{ patInfo.fechaProximaCita | formatoFecha }}</p>
            <p v-else><span class="txt_info">Próxima cita: </span>Sin próxima cita</p>
            <div class="d-flex">
              <p class="mr-1 txt_info">Saldo del paciente:</p>
              <p>{{ patInfo.saldoPaciente | moneda}}</p>
            </div>
        </b-col>
        <b-col class="text-left">
          <div class="borde-derecho"></div>
            <p v-if="edad < 12" class="ml-2" style="font-weight: 600; color: #53BACA;">Contactos del tutor</p>
            <div
              class="ml-2"
              v-if="
                patInfo.telefonoCasa != 'null' ||
                patInfo.telefonoCelular != 'null' ||
                patInfo.telefonoTrabajo != 'null' ||
                patInfo.telefonoCasa != 'null'
              "
            >
              <p v-if="patInfo.telefonoCasa != 'null'">
                <span class="txt_info">Tel. casa:</span>
                  {{
                    patInfo.telefonoCasa
                  }}
              </p>
              <p v-if="patInfo.telefonoCelular != 'null'">
                <span class="txt_info">Tel. móvil:</span>
                  {{
                    patInfo.telefonoCelular
                  }}
              </p>
              <p v-if="patInfo.telefonoTrabajo != 'null'">
                <span class="txt_info">Tel. trabajo:</span>
                  {{
                    patInfo.telefonoTrabajo
                  }}
              </p>
              <p v-if="patInfo.correo != 'null'">
                <span class="txt_info">Correo:</span>
                  {{
                    patInfo.correo
                  }}
                </p>
          </div>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
            style="height: 100%"
          >
            <p class="txt_info">Sin contactos agregados</p>
          </div>
        </b-col>
        <b-col class="ml-2">
          <div class="borde-derecho"></div>
            <p class="txt_info">Planes activos:</p>
            <p v-if="planesActivos != null && planesActivos.length == 0">Sin planes activos</p>
            <div v-else-if="planesActivos != null">
              <div
                v-for="(plan, index) in planesActivos.slice(0, 2)"
                v-bind:key="index"
              >
                <div
                  style="
                    background-color: #a2d2ef;
                    color: #2b5b77;
                    width: max-content;
                    padding: 1% 4%;
                    margin-top: 1%;
                    font-size: 0.85em;
                    font-weight: 600;
                    border-radius: 20px;
                  "
                  @click="showModal(plan)"
                  v-b-tooltip.hover
                  title="Ver detalle del plan"
                >
                  {{ plan.nombrePlan }}
                </div>
              </div>
              <div v-if="planesActivos != null && planesActivos.length > 2">
                <a
                  href="#"
                  id="popover-planes"
                  class="text-left"
                  style="color: #0069a9; font-size: .85em"
                  @click.prevent
                >
                  ver más
                </a>
                <b-popover
                  target="popover-planes"
                  triggers="click blur"
                  placement="bottom"
                  auto-close
                >
                  <div
                    v-for="(plan, index) in planesActivos.slice(2)"
                    v-bind:key="index"
                  >
                    <div
                      style="
                        color: #2b5b77;
                        margin-top: 2%;
                        font-size: 0.85em;
                        font-weight: 600;
                      "
                      @click="showModal(plan)"
                      v-b-tooltip.hover
                      title="Ver detalle del plan"
                    >
                      {{ plan.nombrePlan }}
                    </div>
                  </div>
                </b-popover>
              </div>
            </div>

            <div class="d-flex mt-2" v-if="planesInactivos != null && planesInactivos.length > 0">
              <p class="txt_info">Planes inactivos:</p>
                <a
                  href="javascript:;"
                  @click="showModalhistorialPlanesConvenios()"
                >
                  <em  class="fa fa-eye" ></em>
                </a>
            </div>
            <div v-else class="mt-2">
              <p class="txt_info">Planes inactivos:</p>
              <p v-if="planesInactivos !== null &&  planesInactivos.length === 0">Sin historial de planes</p>
            </div>
          </b-col>
          <b-col
            class="d-flex justify-content-center align-items-center"
          >
            <div
              v-if="
                precaucionesMedicas !== undefined &&
                precaucionesMedicas !== null &&
                precaucionesMedicas.length > 0
              "
            >
              <div
                class="tituloCajaDetallePaciente"
                @click="
                  mostrarPrecaucionesMedicas =
                  !mostrarPrecaucionesMedicas
                "
              >
                <div align="left">Precauciones médicas</div>
                  <div class="ocultarCajaDetallePaciente">
                    <b-icon
                      icon="chevron-up"
                      v-if="mostrarPrecaucionesMedicas"
                    >
                    </b-icon>
                    <b-icon icon="chevron-down" v-else> </b-icon>
                  </div>
              </div>

              <b-collapse v-model="mostrarPrecaucionesMedicas">
                <b-list-group
                  class="borde-rojo"
                  style="
                    height: 80px;
                    overflow: auto;
                    padding: 0px;
                  "
                >
                  <b-list-group-item
                    button
                    v-for="prec in precaucionesMedicas"
                    v-bind:key="prec"
                  >
                    {{ prec }}
                  </b-list-group-item>
                </b-list-group>
              </b-collapse>
            </div>
          <div
            v-else
            class="d-flex justify-content-center align-items-center" style="height: 100%; width: 100%;"
          >
            <p class="txt_info">
              Sin precauciones médicas
            </p>  
          </div>
        </b-col>
      </b-row>
   
      <div class="d-flex justify-content-start w-100">
        <div v-for="(tab, index) in tabsVisibles" v-bind:key="index">
          <div
            class="d-flex justify-content-center flex-column pl-2 pr-5 pt-2"
            v-if="
              $localStorageService.can(tabsVisibles[index].permiso) &&
              evaluarCondicionesAdicionales(tabsVisibles[index].condicionesTab)
            "
            :class="activeTabIndex == index ? 'selected-tab' : 'seleccionable' "
            @click="activeTabIndex = index"
            style="min-width: max-content;"
          >
            <p
              class="m-0 text-center"
              :class="activeTabIndex == index ? '' : 'default-color mb-2'"
            >
              {{ tab.title }}
            </p>
            <hr
              v-if="activeTabIndex == index"
              class="w-50 mx-auto m-0 p-0 mt-2"
              style="height: 0.08em; background-color: #83bee8"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="p-3 mt-3 mr-2"
      style="background-color: white; min-height: 10vh; border-radius: 15px"
    >
      <div class="flex flex-wrap justify-content-start" v-if="tabsVisibles[activeTabIndex].tabs">
        <div
          v-for="(tab, index) in tabsVisibles[activeTabIndex].tabs" 
          v-bind:key="index"
        >
          <div
            :class="subTabIndex == index ? 'selected-subtab' : 'default-subtab'"
            @click="subTabIndex = index"
            v-if="
              $localStorageService.can(
                tabsVisibles[activeTabIndex].tabs[index].permiso
              ) &&
              evaluarCondicionesAdicionales(
                tabsVisibles[activeTabIndex].tabs[index].condicionesTab
              )
            "
          >
            <p 
            class="m-0 text-center"
            :class="subTabIndex == index ? '' : 'default-color'"
            >{{ tab.title }}</p>
          </div>
        </div>
      </div>

      <div
        v-if="
          tabsVisibles.length > activeTabIndex &&
          tabsVisibles[activeTabIndex].tabs
        "
      >
        <component
          class="mt-4"
          v-if="
          mostrarComponente &&
            ((tabsVisibles[activeTabIndex].tabs[subTabIndex].verificarSesion &&
              sesionIniciada) ||
              !tabsVisibles[activeTabIndex].tabs[subTabIndex]
                .verificarSesion) &&
            evaluarCondicionesAdicionales(
              tabsVisibles[activeTabIndex].tabs[subTabIndex]
                .condicionesComponente
            )
          "
          :is="tabsVisibles[activeTabIndex].tabs[subTabIndex].component"
          v-bind="{
            ...tabsVisibles[activeTabIndex].tabs[subTabIndex].props,
            activeTabIndexPerfil: activeTabIndex,
            subTabIndexPerfil: subTabIndex
          }"
          v-on="tabsVisibles[activeTabIndex].tabs[subTabIndex].eventos"
        ></component>
        <RedireccionarAgenda
          v-else-if="
            tabsVisibles[activeTabIndex].tabs[subTabIndex].verificarSesion &&
            !sesionIniciada
          "
        />
      </div>

    </div>

    <div v-if="selectTabM1 == 'tab10M2_PSSDI'">
      <b-row class="mb-4" v-if="patInfo.idPtisinSDI === undefined">
        <b-col class="text-center">
          <b-button variant="primary" disabled>
            <b-spinner small></b-spinner>
            Cargando...
          </b-button>
        </b-col>
      </b-row>
      <b-alert v-if="patInfo.idPtisinSDI === null" show variant="warning"
        >Sin registros</b-alert
      >
      <div
        v-if="patInfo.idPtisinSDI !== undefined && patInfo.idPtisinSDI !== null"
      >
        <presupuestoSinSDI
          :ptiId="patInfo.idPtisinSDI"
          :idPaciente="idPaciente"
          :nombreCompleto="patInfo.nombreCompleto"
        />
      </div>
    </div>

    <b-modal
      v-model="mostrarModalPacientesRelacionados"
      size="xl"
      hide-footer
      title="Parentescos"
    >
      <b-table
        responsive
        :fields="fieldsPacientesRelacionados"
        :items="pacientesRelacionados"
        empty-text="No se encontraron registros"
        show-empty
      >
        <template #cell(id_paciente)="row">
          <p class="trtItem">
            <router-link
              :to="{ name: 'paciente', params: { id: row.item.id_paciente } }"
            >
              {{ row.item.id_paciente }}
            </router-link>
          </p>
        </template>
      </b-table>
    </b-modal>

    <b-modal id="planDetalle" ref="planDetalle" size="xl" hide-footer>
      <template #modal-header class="w-100" style="color: white">
        <div class="d-flex">
           <em class="tabla_diente_svg icon-boton mr-2" style="width: 1.6em; height: 1.6em;"></em>
           <p style="color: white; font-size: 1.2em; font-weight: 600;">Plan activo de {{patInfo.nombreCompleto}}</p>
         </div>
         <em class="close_x_gray" style="width: 10px;" close @click="$bvModal.hide('planDetalle')"></em>
        
      </template>
      <detallePlan
        :vigenciasPlan="detallePlanSeleccionado"
        :paciente="patInfo"
        :empresa-actual="planInfo"
        v-on:regresar="hideModal()"
      ></detallePlan>
    </b-modal>

    <b-modal
      id="historialPlanesConvenios"
      ref="historialPlanesConvenios"
      size="xl"
      hide-footer
      
    >
    <template #modal-header class="w-100">
        <div class="d-flex w-100">
          <em class="tabla_diente_svg icon-boton mr-2" style="width: 1.6%; height: 1.6%;"></em>
          <p style="color: #044169; font-size: 1.2em; font-weight: 600;">Detalle de plan</p>
        </div>
        <em class="close_x_gray" style="width: 10px;" close @click="$bvModal.hide('historialPlanesConvenios')"></em>
      </template>
        
          <div style="min-height: 35vh !important;">
            <p style="color: #53BACA; font-weight: 500;">Registro de planes caducados</p>
            <b-table
            class="mt-4 text-center"
            :items="planesInactivos"
            :fields="fieldsPlanesInactivos"
            responsive
          >
            <template v-slot:cell(Vigencia)="row">
               <span v-if="row.item.idVigenciaSeleccionada == 1">{{ row.item.inicioVigenciaPlan2 | formatoFecha }} - {{ row.item.finVigenciaPlan2 | formatoFecha }}</span>
                <span v-else-if="row.item.idVigenciaSeleccionada == 2">{{ row.item.inicioVigenciaPlan2 | formatoFecha }} - {{ row.item.finVigenciaPlan2 | formatoFecha }}</span>
            </template>
           
          </b-table>
          </div>
    </b-modal>

    <b-modal
        id="modalEditarPaciente"
        size="lg"
        hide-footer
    >
      <template #modal-header class="d-flex justify-content-start w-100">
         <div class="d-flex">
           <em class="tabla_diente_svg icon-boton mr-2" style="width: 1.6em; height: 1.6em;"></em>
           <p style="color: white; font-size: 1.2em; font-weight: 600;">Editar información básica</p>
         </div>
         <em class="close_x_gray" style="width: 10px;" close @click="$bvModal.hide('modalEditarPaciente')"></em>
      </template>

      <b-form @submit.stop.prevent="guardarEdicionPaciente">
      <div>
        <p class="mb-2" style="font-weight: 600; color: #53BACA;">Información general</p>
        <b-row>
          <b-col cols="6">
            <b-form-group class="text-left">
              <label class="label-txt">Nombre(s)</label>
              <b-form-input
                  v-if="patInfo && patInfo.nombre !== undefined" 
                  v-model="patInfo.nombre"
                  minlength="3"
                  :state="patInfo.nombre != '' && patInfo.nombre.length > 2"
                  v-on:keypress="esLetra($event)">
              </b-form-input>
              <b-form-invalid-feedback v-if="!$v.patInfo.nombre.required">
            Este campo es requerido
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.patInfo.nombre.minLength">
            Debe tener al menos 3 caracteres
          </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group class="text-left">
              <label class="label-txt">Apellido paterno</label>
              <b-form-input
                  v-if="patInfo && patInfo.apaterno !== undefined" 
                  v-model="patInfo.apaterno"
                  minlength="3"
                  :state="patInfo.apaterno != '' && patInfo.apaterno.length > 2"
                  v-on:keypress="esLetra($event)">
              </b-form-input>
              <b-form-invalid-feedback v-if="!$v.patInfo.apaterno.required">
            Este campo es requerido
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.patInfo.apaterno.minLength">
            Debe tener al menos 3 caracteres
          </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-4">
            <b-form-group class="text-left">
              <label class="label-txt">Apellido materno</label>
              <b-form-input
              v-if="patInfo && patInfo.amaterno !== undefined" 
                  v-model="patInfo.amaterno"
                  minlength="3"
                  :state="patInfo.amaterno != '' && patInfo.amaterno.length > 2"
                  v-on:keypress="esLetra($event)">
              </b-form-input>
              <b-form-invalid-feedback v-if="!$v.patInfo.amaterno.required">
            Este campo es requerido
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.patInfo.amaterno.minLength">
            Debe tener al menos 3 caracteres
          </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-4">

            <b-form-group>
              <label class="label-txt">Fecha de nacimiento</label>
              <b-form-datepicker
                  id="fechacita-datepicker"
                  labelNoDateSelected="Fecha"
                  range
                  v-model="patInfo.fechaNacimientoDate"
                  class="mb-2"
                  in
                  no-flip
                  :max="new Date()"
              ></b-form-datepicker>
              <b-form-invalid-feedback v-if="!$v.patInfo.fechaNacimientoDate.required">
            Este campo es requerido
          </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="6" class="mt-4">
            <b-form-group class="text-left">
              <label class="label-txt">Sexo</label>
              <b-form-select
                  :options="listaSexo"
                  text-field="text"
                  value-field="value"
                  v-model="patInfo.idSexo">
              </b-form-select>
              <b-form-invalid-feedback v-if="!$v.patInfo.idSexo.required">
            Este campo es requerido
          </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

        <div style="min-height: 20vh;">
          <ContactosCardPaciente v-if="edadCalculada >= 12" class="mt-3" :idPaciente="idPaciente" @actualizarContactos="actualizarContactos" ></ContactosCardPaciente>
          <TutoresEdicionPaciente v-else :parentesco = "parentesco" @actualizarParentesco="actualizarParentesco"></TutoresEdicionPaciente>
        </div>

      <div class="d-flex justify-content-center">
        <b-button class="mt-2 mr-4" type="submit" variant="primary">Guardar</b-button>
        <b-button class="mt-2" @click="cancelarEdicion()">Cancelar</b-button>
      </div>
        </b-form>
    </b-modal>
  </div>
</template>
<script>
import { minLength, required} from "vuelidate/lib/validators";
//components
import Header from "../components/Header.vue";
import needsDetection from "./perfilPacientes/historialClinica/needsDetection.vue";
import Presupuesto from "./perfilPacientes/Presupuesto.vue";
import hojasCDX from "./perfilPacientes/hojasCDX.vue";
import prosecutors from "./perfilPacientes/prosecutors.vue";
import documents from "./perfilPacientes/documents.vue";
import resumenPTI from "./perfilPacientes/resumenPTI.vue";
import diagnosticTools from "./perfilPacientes/diagnosticTools.vue";
import historiaReplica from "./perfilPacientes/historiaReplica.vue";
// import detallePtiOg from "./perfilPacientes/detallePtiOg";
import empatia from "./perfilPacientes/Empatia.vue";
import edicionPTI from "./perfilPacientes/edicionPTI.vue";
import tratamientosprogramados from "./Pagos/tratamientosprogramados.vue";
import presupuestoSinSDI from "./PTI/PresupuestoSinSDI.vue";
import RedireccionarAgenda from "../components/RedireccionarAgenda.vue";
import HistorialCirtas from "./Paciente/HistorialCirtas";

import detallePlan from "./Empresas/Empresas/detallePlan";
import moment from "moment";
import PresupuestoHistoricoV4 from "@/views/perfilPacientes/PresupuestoHistoricoV4";

import ExpedienteDigital from "@/views/ExpedienteDigitalPaciente/ExpedienteDigital";
import HojaDiagnosticoComponente from "../components/hojasDiagnostico/HojaDiagnosticoComponente.vue";

import NotasPacientePTI from "@/components/PTI/nuevoM2/NotasPacientePTI";

import BandejaInterconsulta from "../components/Interconsulta/BandejaInterconsulta";

import QuejasPaciente from "@/views/Garantias/GaratiasRAS/QuejasPaciente";
import activacionTratamientos from "./Pagos/activacionTratamientos.vue";
import avptIndex from "@/views/avpt/avptIndex";
import HojaDiagnosticoDescentralizadoComponente from "@/components/hojasDiagnostico/HojaDiagnosticoDescentralizadoComponente";
import HojaDiagnostico from "../version5/diagnostico/HojaDiagnostico.vue";

import PatientJourneyV2 from "@/components/PatientJourneyV2";
import VersionesPTI from "@/views/PTI/VersionesPTI.vue";
import BandejaHcs from "@/views/perfilPacientes/historialClinica/BandejaHcs";
import HistoriaClinicaV2 from "@/views/perfilPacientes/historialClinica/HistoriaClinicaV2";
import HistoriaNinoV2 from "@/views/perfilPacientes/historialClinica/HistoriaNinoV2";
import HistoriaEmergenciaV2 from "@/views/perfilPacientes/historialClinica/HistorialEmergenciaV2";
import Cuponera from "@/views/perfilPacientes/cuponera.vue";
import historialPTI from "@/views/historialPTI/historialPTI.vue";
import BloqueoPti from "@/components/BloqueoPti/BloqueoPti";
import ImpresionPtiv5 from "@/version5/negociacion/ImpresionPtiv5.vue";
import DiagnosticoInicialPTI from "@/components/PTI/nuevoM2/DiagnosticoInicialPTI.vue";
import HistorialBandejasPorPacienteComponente from "@/components/bandejas/HistorialBandejasPorPacienteComponente";
import HistorialHojasBienvenida from "@/components/HistorialHojasBienvenida.vue";
import SesionesRealizadas from "@/views/Pagos/sesionesRealizadas.vue";
import ContactosCardPaciente from "@/components/paciente/ContactosCardPaciente.vue"
import TutoresEdicionPaciente from "@/components/paciente/tutores/TutoresEdicionPaciente.vue"
import BandejaOdts from "@/views/LaboratorioV2/SolicitudODT/BandejaOdts.vue";

export default {
  name: "Paciente",
  components: {
    TutoresEdicionPaciente,
    ContactosCardPaciente,
    ImpresionPtiv5,
    BloqueoPti,
    Cuponera,
    HistoriaEmergenciaV2,
    HistoriaNinoV2,
    HistoriaClinicaV2,
    BandejaHcs,
    PatientJourneyV2,
    HojaDiagnosticoDescentralizadoComponente,
    HojaDiagnostico,
    QuejasPaciente,
    NotasPacientePTI,
    PresupuestoHistoricoV4,
    Header,
    needsDetection,
    Presupuesto,
    hojasCDX,
    prosecutors,
    documents,
    resumenPTI,
    diagnosticTools,
    empatia,
    historiaReplica,
    SesionesRealizadas,
    tratamientosprogramados,
    presupuestoSinSDI,
    RedireccionarAgenda,
    HistorialCirtas,
    detallePlan,
    edicionPTI,
    ExpedienteDigital,

    HojaDiagnosticoComponente,

    BandejaInterconsulta,
    activacionTratamientos,
    avptIndex,
    VersionesPTI,
    historialPTI,
    DiagnosticoInicialPTI,
    HistorialBandejasPorPacienteComponente,
    BandejaOdts
  },
  props: {
    personalizacionIconos: {
      type: Boolean,
      default: true,
    },
    vistaCompleta: {
      type: Boolean,
      default: true,
    },
    propIdPaciente: Number,
    propIdSesionSeleccionada: Number,
  },
  data() {
    return {
      mostrarComponente: true,
      tutor: null,
      registrosPorPagina: 6,
      paginaActual: 1,
      filter: null,
      tutores: [],
      listaSexo: [],
      detallePlanSeleccionado: null,
      planesActivos: null,
      planesInactivos: null,
      pestaniasMenu: [],
      activeTabIndex: 0,
      subTabIndex: 0,
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      precaucionesMedicas: [],
      loaderPrecMed: false,
      planesConvenios: [],
      loaderPlanes: false,
      existeRechazoDesentralizado: false,
      idPtiRechazo: null,
      etapaRechazo: null,
      solicitudRechazo: null,
      vecesRechazo: 0,
      tipoHc: 0,
      idHistoriaClinica: 0,
      activarGuardar: true,
      itemsTabs: [],
      mostrarPrecaucionesMedicas: true,
      showOptions: false,
      selectTabM1: "tab1M1_AVPT",
      selectTabM2: "",
      origen: "paciente",
      loading: false,
      loadingSesion: false,
      //  nivelSalud: [],
      doctores: [],
      listaPadecimientosActivosPertenecientesADientes: [],

      padecimientosNino: [],
      padecimientosAdulto: [],
      padecimientosMixto: [],
      patInfo: {},
      estatusSolicitud: 0,
      clinicas: [],
      id: 0,
      id_denticion: 0,
      colorSelected: "",
      tipoSelected: "",
      personalidadSelected: "",
      descripcion: "",
      patientColor: { id: 1, name: "Rojo", color: "#ff0000" },
      colorArray: [
        { id: 1, name: "Rojo", color: "#ff0000" },
        { id: 2, name: "Amarillo", color: "#ffff00" },
        { id: 3, name: "Azul", color: "#0000ff" },
        { id: 4, name: "Verde", color: "#008000" },
      ],
      tipoArray: [
        { id: 1, name: "Reactivo" },
        { id: 1, name: "Estético" },
        { id: 1, name: "Preventivo" },
      ],
      personalidadArray: [
        { id: 1, name: "Directa" },
        { id: 1, name: "Emotivo" },
        { id: 1, name: "Lógico" },
        { id: 1, name: "Lógico directo" },
      ],
      percent: { name: "Tratamientos", amount: 50, buffer: 0 },
      active: "four",
      first: false,
      second: false,
      third: false,
      four: false,
      five: false,
      six: false,
      token: null,
      idPaciente: null,
      idSesionSeleccionada: null,
      opcionSel: null,
      edad: null,
      sesionIniciada: false,
      idClinica: null,
      planInfo: [],
      parentesco: null,
      sesionDia: { herramientas: false },
      fieldsContactos: [
        {
          key: "medioContacto",
          label: "Medio",
        },
        {
          key: "contacto",
          label: "Datos",
        },
        {
          key: "preferente",
          label: "Preferente",
        },
       "Acciones"
      ],
      fieldsPlanesInactivos: [
        {
          key: "idPlan",
          label: "ID plan",
        },
        {
          key: "nombrePlan",
          label: "Nombre plan",
        },
        {
          key: "nombreTipoPlan",
          label: "Tipo plan",
        },
        {
          key: "tipoAsegurado",
          label: "Tipo asegurado",
        },
        {
          key: "nombreCompania",
          label: "Nombre empresa",
        },
        {
          key: "nombreVigenciaSeleccionada",
          label: "Tipo vigencia",
        },
          "Vigencia"
      ],
      fieldsPlanes: [
        {
          key: "nombrePlan",
          label: "PLAN",
        },
        {
          key: "numeroPoliza",
          label: "PÓLIZA",
        },
        {
          key: "inicioVigencia",
          label: "VIGENCIA",
        },
      ],
      verConsentimientos: null,
      windowWidth: window.innerHeight,
      success: false,
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
      blnClinicaDescentralizada: false,
      menuTexto: true,
      selected: 1,
      images: [],

      mostrarModalPacientesRelacionados: false,
      pacientesRelacionados: null,
      fieldsPacientesRelacionados: [
        {
          key: "id_paciente",
          label: "ID",
        },
        {
          key: "nombre_completo",
          label: "Paciente",
        },
        {
          key: "parentezco",
          label: "Relación",
        },
      ],

      bloquedoSinSDI: true,
      bloquedoEditarPTI: true,
      modalEditarPaciente: false,
      listaContactos: [],
      parentescoLocal: null,
      contactosPaciente: null,
      edadCalculada: null,
    };
  },

  watch: {
    activeTabIndex() {
      this.setFirstAvailableSubTab();
    },

    tipoHc(){
      this.recargarComponente();
    },

    "patInfo.fechaNacimientoDate"(newDate) {
      if (newDate) {
        this.edadCalculada = this.calcularEdad(newDate);
      } else {
        this.edadCalculada = null;
      }
    },

    patInfo(){
      this.llenarTabs();
    },

    existeRechazoDesentralizado(){
      this.llenarTabs();
    }
  },

  computed: {
    
    tabsVisibles() {
      return this.pestaniasMenu.filter((tab) =>
        tab.tabs.some((subTab) => this.$localStorageService.can(subTab.permiso))
      );
    },
  },

  //comment to commit
  async created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerPreferenciaMenu();
    //this.obtenerIdConvenios();

    this.obtenerMedidaPantalla();

    if (
      this.propIdPaciente !== undefined &&
      this.propIdPaciente !== null &&
      this.propIdPaciente > 0
    ) {
      this.idPaciente = this.propIdPaciente;
    } else {
      this.idPaciente = Number(this.$route.params.id);
    }

    if (
      this.propIdSesionSeleccionada !== undefined &&
      this.propIdSesionSeleccionada !== null &&
      this.propIdSesionSeleccionada > 0
    ) {
      this.idSesionSeleccionada = this.propIdSesionSeleccionada;
    } else {
      this.idSesionSeleccionada = this.$route.params.sesion;
    }
   
    this.idClinica = this.$localStorageService.getIdClinica();
    this.verConsentimientos = await this.vadicionActivarEceClinica();
    await this.llenarListaDetallePaciente();
    this.llenarListaClinicas();
    this.llenarListaPadecimientos();
    this.llenarListaDoctores();
    this.traerSesionActiva();
    this.onTabSelected();
    this.obtenerParentescoDelPaciente();
    this.obtenerClinicaTieneDesentralizado();
    await this.existePtiRechazado();

    //Funcionalidad persistencia de tabs para laboratorio
    const savedActiveTabIndex = this.$localStorageService.getActiveTabPacientePerfil();

    if (savedActiveTabIndex !== null) {
      this.activeTabIndex = parseInt(savedActiveTabIndex);
      this.$localStorageService.removeActiveTabPacientePerfil();
    }


  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
    
  },
  validations() {
    return {
      patInfo: {
        nombre: { required, minLength: minLength(3) },
        amaterno: { required, minLength: minLength(3) },
        apaterno: { required, minLength: minLength(3) },
        fechaNacimientoDate: { required },
        idSexo: { required }
      }
    };
  },
  methods: {
    calcularEdad(fechaNacimiento) {
    const nacimiento = new Date(fechaNacimiento);
    const hoy = new Date();
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mesDiferencia = hoy.getMonth() - nacimiento.getMonth();
    const diaDiferencia = hoy.getDate() - nacimiento.getDate();

    if (mesDiferencia < 0 || (mesDiferencia === 0 && diaDiferencia < 0)) {
      edad--;
    }
    return edad;
  },
    recargarComponente() {
    this.mostrarComponente = false;
    this.$nextTick(() => {
      this.mostrarComponente = true;
    });
  },
    validateState(field) {
      const { $dirty, $error } = this.$v.patInfo[field];
      return $dirty ? !$error : null;
    },
    esLetra(e) {
      let char = e.key;
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ0-9\s]$/.test(char)) return true;
      else e.preventDefault();
    },

    actualizarContactos(nuevosContactos) {
      this.contactosPaciente = nuevosContactos;
    },
    guardarEdicionPaciente(){
      this.$v.$touch(); 
      if (this.$v.$invalid) return; 

      const usuario = this.$localStorageService.getIdUsuario();
      this.loading = true;
      const fechaNacimiento = this.$moment(this.patInfo.fechaNacimientoDate).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");

      const datos = {
        idPaciente: this.patInfo.idPaciente,
        nombrePaciente: this.patInfo.nombre,
        apellidoPaterno: this.patInfo.apaterno,
        apellidoMaterno: this.patInfo.amaterno,
        fechaNacimiento: fechaNacimiento,
        sexo: this.patInfo.idSexo,
        idpacientePadre: this.parentescoLocal && this.parentescoLocal.idPacientePadre ? this.parentescoLocal.idPacientePadre : null,
        idParentesco: this.parentescoLocal && this.parentescoLocal.idParentesco ? this.parentescoLocal.idParentesco : null,
        finComercial: this.patInfo.finesComerciales == null ? false : this.patInfo.finesComerciales,
        idPersona: this.patInfo.personaId,
        usuarioLogeado: usuario,
        contactosPaciente: this.contactosPaciente
      }

      let urlPaciente =
          this.$api +
          "paciente/actualizarDatosBasicosPx" ;

      this.$http
          .put(urlPaciente, datos)
          .then((response) => {
            if(response){
              this.$swal({
                icon: "info",
                title: "Paciente actualizado correctamente",
                confirmButtonText: "De acuerdo",
                confirmButtonColor: "#0e6ba9"
              })
            }
            this.parentesco = this.parentescoLocal;
            this.obtenerParentescoDelPaciente();
            this.llenarListaDetallePaciente();
          }).catch((err) => {
        console.error(err);
        this.$swal({
          icon: "error",
          title: "Ocurrió un error",
          text: "Ocurrió un error, por favor inténtelo más tarde",
          confirmButtonText: "De acuerdo",
          confirmButtonColor: "#0e6ba9"
        })
      }).finally(() => {
        this.loading = false;
      });
    },
    cancelarEdicion(){
      this.modalEditarPaciente = false;
      this.$bvModal.hide("modalEditarPaciente");
      this.$v.$reset();
     
      this.obtenerParentescoDelPaciente();
    },
    actualizarParentesco(nuevoParentesco) {
      this.parentescoLocal = nuevoParentesco;

    },
   
    abrirEditarPaciente(){
      this.loading = true;
      this.traerListaSexo();
      this.loading = false;
      this.$bvModal.show("modalEditarPaciente");
    },
    traerListaSexo() {
      let urlSexo = this.$api + "catalogos/listaSexo";
      this.$http
          .post(urlSexo)
          .then((response) => {
            if (response.data.data) {
              this.listaSexo = response.data.data;
            }
          })
          .catch(function (err) {
            console.error(err);
          });
    },
    tipoHistoria() {
      if(this.pestaniasMenu[2]){
switch (this.tipoHc) {
        case 0:
          this.pestaniasMenu[2].tabs[1].component = BandejaHcs
          break;
          case 1:
          this.pestaniasMenu[2].tabs[1].component = HistoriaNinoV2
          break;
          case 2:
          this.pestaniasMenu[2].tabs[1].component = HistoriaClinicaV2
          break;
          case 3:
          this.pestaniasMenu[2].tabs[1].component = HistoriaEmergenciaV2
          break;
      
        default:
          break;
      }
      }
      return this.tipoHc === 0
        ? BandejaHcs
        : this.tipoHc === 1
        ? HistoriaNinoV2
        : this.tipoHc === 2
        ? HistoriaClinicaV2
        : this.tipoHc === 3
        ? HistoriaEmergenciaV2
        : null;
    },
    llenarTabs() {
      this.pestaniasMenu = [
        {
          title: "Presupuesto SDI",
          permiso: "BT_Presupuesto_SDI",
          condicionesTab: "",
          tabs: [
            {
              title: "AVPTx",
              component: avptIndex,
              permiso: "BT_03_ver_avpt",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                idPacienteAVPT: this.idPaciente,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Presupuesto histórico v3",
              component: Presupuesto,
              permiso: "CA_03_presupuesto",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                idPaciente: this.idPaciente,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Presupuesto histórico v4",
              component: PresupuestoHistoricoV4,
              permiso: "CA_03_presupuesto",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                idPaciente: this.idPaciente,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Resúmen PTI",
              component: resumenPTI,
              permiso: "CA_03_resumen_pti",
              verificarSesion: false,
              condicionesTab: "",
              props: {},
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Seguimiento de PTI",
              component: HistorialBandejasPorPacienteComponente,
              permiso: "BJ_historial_solicitudes",
              verificarSesion: false,
              condicionesTab: "",
              props: {},
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "HDx",
              component: hojasCDX,
              permiso: "ECE_01_principal",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                idPaciente: this.idPaciente,
                padecimientosNino: this.padecimientosNino,
                padecimientosAdulto: this.padecimientosAdulto,
                padecimientosMixto: this.padecimientosMixto,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Diágnostico inicial",
              component: DiagnosticoInicialPTI,
              permiso: "BT_Diagnostico_inicial",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                paciente: this.patInfo,
                contraerCard: true,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Solicitud PTI niño",
              component: HojaDiagnosticoComponente,
              permiso: "CA_03_solicitud_pti_nino",
              verificarSesion: true,
              condicionesTab:
                "!this.blnClinicaDescentralizada && this.patInfo.edadPaciente <= 6",
              props: {
                titulo: "Solicitud de PTI niño",
                subtitulo: "Diagnóstico",
                codigo: "CA_03_19",
                idPaciente: Number(this.idPaciente),
                idSesionSeleccionada: Number(this.idSesionSeleccionada),
                doctores: this.doctores,
                idDenticion: 1,
                esSdi: true,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Solicitud PTI mixto",
              component: HojaDiagnosticoComponente,
              permiso: "CA_03_solicitud_pti_mix",
              verificarSesion: true,
              condicionesTab:
                "this.patInfo.edadPaciente >= 7 && this.patInfo.edadPaciente < 12 && !this.blnClinicaDescentralizada",
              props: {
                titulo: "Solicitud de PTI  MIXTO",
                subtitulo: "Diagnóstico",
                codigo: "CA_03_20",
                idPaciente: Number(this.idPaciente),
                idSesionSeleccionada: Number(this.idSesionSeleccionada),
                doctores: this.doctores,
                idDenticion: 3,
                esSdi: true,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Solicitud PTI",
              component: HojaDiagnosticoDescentralizadoComponente,
              permiso: "CA_03_solicitud_pti_adul",
              verificarSesion: true,
              condicionesTab:
                "this.blnClinicaDescentralizada === false && this.sesionDia.herramientas",
              props: {
                titulo: "SOLICITUD DE PTI",
                subtitulo: "Diagnóstico",
                codigo: "CA_03_19",
                idPaciente: Number(this.idPaciente),
                idSesionSeleccionada: Number(this.idSesionSeleccionada),
                doctores: this.doctores,
                descentralizado: false,
                idDenticion: 2,
                esSdi: true,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Solicitud PTI Descentralizado",
              component: HojaDiagnostico,
              permiso: "CA_03_solicitud_pti_desen",
              verificarSesion: true,
              condicionesTab:
                this.edad > 12
                  ? "this.blnClinicaDescentralizada && this.sesionDia.herramientas"
                  : "this.blnClinicaDescentralizada",
              props: {
                contraerCard: true,
                idPaciente: this.patInfo.idPaciente,
                paciente: this.patInfo,
                idSesionSeleccionada: Number(this.idSesionSeleccionada),
                doctores: this.doctores,
                idDenticion: 2,
                existeRechazoDesentralizado: this.existeRechazoDesentralizado,
                idPtiRechazo: this.idPtiRechazo,
                etapaRechazo: this.etapaRechazo,
                solicitudRechazo: this.solicitudRechazo,
              },
              eventos: {
                ptiCreado: this.ptiCreado,
              },
              condicionesComponente:
                "this.sesionIniciada || this.existeRechazoDesentralizado",
            },
            {
              title: "Detalle PTI OG",
              component: HojaDiagnosticoDescentralizadoComponente,
              permiso: "PT_01_pti_descentr_01",
              verificarSesion: false,
              condicionesTab:
                "this.blnClinicaDescentralizada && this.patInfo.idPtiActivo != null && this.patInfo.idPtisinSDI == null",
              props: {
                titulo: "DETALLE HOJA DIAGNOSTICO OG",
                subtitulo: "Diagnóstico",
                codigo: "CA_03_1",
                "id-paciente": this.idPaciente,
                "id-denticion": 2,
                detalle: true,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Detalle PTI CDx",
              component: HojaDiagnosticoDescentralizadoComponente,
              permiso: "PT_01_pti_presuntivo",
              verificarSesion: false,
              condicionesTab:
                "this.patInfo.idPtiActivo != null && this.patInfo.idPtisinSDI == null",
              props: {
                titulo: "DETALLE HOJA DIAGNOSTICO OG",
                subtitulo: "Diagnóstico",
                codigo: "CA_03_19",
                "id-paciente": this.idPaciente,
                "id-denticion": 2,
                "id-pti-cdx": this.patInfo.idPti,
                detalle: true,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Impresión PTI",
              component: ImpresionPtiv5,
              permiso: "PR_01_imprimir_presen",
              verificarSesion: false,
              condicionesTab:
                "this.patInfo.idPti !== null && this.patInfo.ptiNuevoM2 === true",
              props: {
                props: true,
                idPtiProp: this.patInfo.idPti,
                opcionProp: this.opcionSel,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Historial PTI",
              component: historialPTI,
              permiso: "BT_Detalle_PTI",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                "propid-paciente": this.idPaciente,
                nombrePaciente: this.patInfo.nombreCompleto,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Consultas PTI",
              component: VersionesPTI,
              permiso: "PR_01_consultar_vers_PTI",
              verificarSesion: false,
              condicionesTab:
                "this.patInfo.idPti !== null && this.patInfo.idPti !== undefined",
              props: {
                "propid-paciente": this.idPaciente,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Notas PTI",
              component: NotasPacientePTI,
              permiso: "Notas_01_M2",
              verificarSesion: false,
              condicionesTab:
                "this.patInfo.idPti !== null && this.patInfo.idPti !== undefined",
              props: {
                idPti: this.patInfo.idPti,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Ajuste diagnóstico",
              component: edicionPTI,
              permiso: "AD_01_ajuste_dx",
              verificarSesion: false,
              condicionesTab:
                "this.patInfo.idPti !== null && this.patInfo.idPti !== undefined",
              props: {
                ptiId: this.patInfo.idPti,
              },
              eventos: {},
              condicionesComponente: "",
            },
          ],
        },
        {
          title: "Presupuesto NO SDI",
          permiso: "BT_Presupuesto_No_SDI",
          condicionesTab: "'idPtisinSDI' in this.patInfo",
          tabs: [
            {
              title: "Hdx niño",
              component: HojaDiagnosticoComponente,
              permiso: "CA_03_sol_nino_sinsdi",
              verificarSesion: true,
              condicionesTab: "this.patInfo.edadPaciente <= 6",
              props: {
                titulo: "DIAGNÓSTICO NIÑO (NO ENTRA SDI)",
                subtitulo: "Diagnóstico",
                codigo: "CA_03_sol_nino_sinsdi",
                idPaciente: Number(this.idPaciente),
                idSesionSeleccionada: Number(this.idSesionSeleccionada),
                doctores: this.doctores,
                idDenticion: 1,
                esSdi: false,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Hdx adulto",
              component: HojaDiagnosticoComponente,
              permiso: "CA_03_sol_adul_sinsdi",
              verificarSesion: true,
              condicionesTab:
                "!this.sesionDia.herramientas && this.patInfo.edadPaciente >= 13",
              props: {
                titulo: "DIAGNÓSTICO ADULTO (NO ENTRA SDI)",
                subtitulo: "Diagnóstico",
                codigo: "CA_03_sol_adul_sinsdi",
                idPaciente: Number(this.idPaciente),
                idSesionSeleccionada: Number(this.idSesionSeleccionada),
                doctores: this.doctores,
                idDenticion: 1,
                esSdi: false,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Hdx mixto",
              component: HojaDiagnosticoComponente,
              permiso: "CA_03_sol_mixto_sinsdi",
              verificarSesion: true,
              condicionesTab:
                "this.patInfo.edadPaciente >= 7 && this.patInfo.edadPaciente <= 12",
              props: {
                titulo: "DIAGNÓSTICO MIXTO (NO ENTRA SDI)",
                subtitulo: "Diagnóstico",
                codigo: "CA_03_sol_mixto_sinsdi",
                idPaciente: Number(this.idPaciente),
                idSesionSeleccionada: Number(this.idSesionSeleccionada),
                doctores: this.doctores,
                idDenticion: 3,
                esSdi: false,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Presupuesto",
              component: presupuestoSinSDI,
              permiso: "CA_03_presup_nosdi",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                ptiId: this.patInfo.idPtisinSDI,
                idPaciente: this.idPaciente,
                nombreCompleto: this.patInfo.nombreCompleto,
              },
              eventos: {},
              condicionesComponente: "",
            },
          ],
        },
        {
          title: "ECE",
          permiso: "ECE_01_principal",
          condicionesTab: "",
          tabs: [
            {
              title: "ECE",
              component: ExpedienteDigital,
              permiso: "ECE_01_principal",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                idPacienteExp: this.idPaciente,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Historiales Clínicos",
              component: this.tipoHistoria(),
              permiso: "BT_ECE_HisticialClinico",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                idPaciente: this.idPaciente,
                idHistoriaClinica: this.idHistoriaClinica,
                activarGuardar: this.activarGuardar,
              },
              eventos: {
                mostrarTipoHistoriaClinica: this.mostrarTipoHistoriaClinica,
              },
              condicionesComponente: "",
            },
            {
              title: "Herramientas de diagnóstico",
              component: diagnosticTools,
              permiso: "CA_03_herram_dx",
              verificarSesion: false,
              condicionesTab: "",
              props: {},
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Interconsulta",
              component: BandejaInterconsulta,
              permiso: "IC_01_intercosulta",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                idPaciente: this.idPaciente,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Detección de necesidades",
              component: needsDetection,
              permiso: "CA_03_detect_necesidades",
              verificarSesion: false,
              condicionesTab: "",
              props: {},
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Mapa de empatía",
              component: empatia,
              permiso: "CA_08_empatia",
              verificarSesion: false,
              condicionesTab: "",
              props: {},
              eventos: {},
              condicionesComponente: "",
            },
          ],
        },
        {
          title: "Historial de citas",
          permiso: "BT_Historial_citas",
          condicionesTab: "",
          tabs: [
            {
              title: "Historial de citas",
              component: HistorialCirtas,
              permiso: "CT_01_consu_citas",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                paciente: this.idPaciente,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Historial de Hojas de Bienvenida",
              component: HistorialHojasBienvenida,
              permiso: "Historial_HJBienveni_01",
              verificarSesion: false,
              condicionesTab: "",
              props: {},
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Recibos",
              component: documents,
              permiso: "CA_03_documentos",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                pti: this.patInfo.idPti,
              },
              eventos: {},
              condicionesComponente: "",
            },
          ],
        },
        {
          title: "Tratamientos",
          permiso: "CA_03_tx_programados",
          condicionesTab: "",
          tabs: [
            {
              title: "Tratamientos",
              component: tratamientosprogramados,
              permiso: "CA_03_tx_programados",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                "id-paciente": this.idPaciente,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Sesiones realizadas",
              component: SesionesRealizadas,
              permiso: "CA_03_sesiones",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                "id-paciente": this.idPaciente,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Tx activar / inactivar",
              component: activacionTratamientos,
              permiso: "Tx_01_activo_inactivo",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                "id-paciente": this.idPaciente,
              },
              eventos: {},
              condicionesComponente: "",
            },
            {
              title: "Laboratorio",
              component: BandejaOdts,
              permiso: "BT_odt_lab",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                "idPaciente": this.idPaciente,
                "sexo": this.patInfo.idSexo !== null ? this.patInfo.idSexo : 0,
                "edad" : this.patInfo.edadPaciente,
                "nombrePaciente": this.patInfo.nombreCompleto,
                "tipoPantalla": 2,
                "activeTabIndexPerfil": this.activeTabIndex,   // <-- Persistencia tabs Laboratorio
                "subTabIndexPerfil": this.subTabIndex // <--- Persistencia tabs laboratorio
              },
              eventos: {},
              condicionesComponente: "",
            },
          ],
        },
        {
          title: "Quejas",
          permiso: "Icono_01_quejas",
          condicionesTab: "",
          tabs: [
            {
              title: "Quejas",
              component: QuejasPaciente,
              permiso: "Icono_01_quejas",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                idPaciente: this.patInfo.edadPaciente,
                nombreCompleto: this.patInfo.nombreCompleto,
                vistaFiltrado: false,
              },
              eventos: {},
              condicionesComponente: "",
            },
          ],
        },
        {
          title: "Datos fiscales",
          permiso: "CA_03_fiscales",
          condicionesTab: "",
          tabs: [
            {
              title: "Datos fiscales",
              component: prosecutors,
              permiso: "CA_03_fiscales",
              verificarSesion: false,
              condicionesTab: "",
              props: {},
              eventos: {},
              condicionesComponente: "",
            },
          ],
        },
        {
          title: "Cupones",
          permiso: "BT_Cupones",
          condicionesTab: "",
          tabs: [
            {
              title: "Cupones",
              component: Cuponera,
              permiso: "BT_Cupones",
              verificarSesion: false,
              condicionesTab: "",
              props: {
                idPaciente: this.idPaciente,
              },
              eventos: {},
              condicionesComponente: "",
            },
          ],
        },
      ];
      this.setFirstAvailableSubTab();

    },
    evaluarCondicionesAdicionales(condicion) {
      if (condicion.trim() === "") {
        console.warn("Condición vacía, evaluando como false.");
        return true;
      }
      try {
        return new Function("return " + condicion).call(this);
      } catch (e) {
        console.error("Error al evaluar la condición:", e);
        return false;
      }
    },

    setFirstAvailableSubTab() {
      const tabs = this.tabsVisibles[this.activeTabIndex].tabs;
      const firstAvailableIndex = tabs.findIndex(
        (tab) =>
          this.$localStorageService.can(tab.permiso) &&
          this.evaluarCondicionesAdicionales(tab.condicionesTab)
      );

      this.subTabIndex = firstAvailableIndex !== -1 ? firstAvailableIndex : 0; // Si ninguna pestaña tiene permiso, deja en 0

      //Funcionalidad tabs laboratorio
      const savedSubTabIndex = this.$localStorageService.getActiveSubTabPacientePerfil();

      if (savedSubTabIndex !== null) {
        this.subTabIndex = parseInt(savedSubTabIndex);
        this.$localStorageService.removeActiveSubTabPacientePerfil();
      }
    },
    mostrarTipoHistoriaClinica(hc, idHc, activarGuardar, clickBandeja) {
      const subTabIndex = this.subTabIndex;
      this.tipoHc = hc;
      this.idHistoriaClinica = idHc;
      this.activarGuardar = activarGuardar;
      this.tipoHistoria();
      if(clickBandeja){
        this.llenarTabs();
        this.subTabIndex = subTabIndex;
      }
    },
    obtenerIdConvenios() {
      /* this.patInfo.planesConvenios.map(plan => this.images.push(plan.idEmpresa)); */
    },

    obtenerPreferenciaMenu() {
      this.$http
        .get(
          this.$api +
            "preferenciasUsuario/obtenerPreferencia/pacientes_perfiles/menu"
        )
        .then((response) => {
          this.menuTexto = response.data.data;
          this.selected = this.menuTexto ? 1 : 2;
          //de momento todos los menus van a ser texto
          this.menuTexto = true;
          this.selected = 1;
        });
    },

    seleccionarNv1(tab) {
      this.selectTabM1 = tab;
      this.seleccionarNv2();
    },
    seleccionarNv2(tab) {
      this.selectTabM2 = tab;
      this.tipoHc = 0;
    },
    mostrarTab(tab) {
      if (tab === "nv1_PTI") {
        //Presupuesto SDI
        return (
          (this.$localStorageService.can("BT_Presupuesto_SDI") &&
            this.mostrarTab("nv2_AVPT")) ||
          this.mostrarTab("nv2_PHV3") ||
          this.mostrarTab("nv2_PHV4") ||
          this.mostrarTab("nv2_DTPTIACT") ||
          this.mostrarTab("nv2_RESPTI") ||
          this.mostrarTab("nv2_BJHS") ||
          this.mostrarTab("nv2_HDXSDI") ||
          this.mostrarTab("nv2_HDXSDIADUL") ||
          this.mostrarTab("nv2_HDXSDININ") ||
          this.mostrarTab("nv2_HDXSDIMIX") ||
          this.mostrarTab("nv2_SPTDSTZD") ||
          this.mostrarTab("nv2_SPA") ||
          this.mostrarTab("nv2_DETPTIOG") ||
          this.mostrarTab("nv2_IMPSNPTI") ||
          this.mostrarTab("nv2_VRSNIMPSNPTI") ||
          this.mostrarTab("nv2_NTSPPTI") ||
          this.mostrarTab("nv2_AJSTDGNSTC") ||
          this.mostrarTab("nv2_PTIALTR")
        );
      }

      if (tab === "nv1_FSDI") {
        //>Fuera de SDI
        return (
          (this.$localStorageService.can("BT_Presupuesto_No_SDI") &&
            this.mostrarTab("nv2_HDXN")) ||
          this.mostrarTab("nv2_HDXA") ||
          this.mostrarTab("nv2_HDXM") ||
          (this.mostrarTab("nv2_PRES") && this.patInfo.idPtisinSDI != undefined)
        );
      }

      if (tab === "nv1_ECE") {
        //ECE
        return (
          (this.$localStorageService.can("BT_ECE") &&
            this.mostrarTab("nv2_HDXSDI")) ||
          this.mostrarTab("nv2_HTRCN") ||
          this.mostrarTab("nv2_HTRCA") ||
          this.mostrarTab("nv2_HTRCE") ||
          this.mostrarTab("nv2_HRRDAG") ||
          this.mostrarTab("nv2_CNSNTMTS") ||
          this.mostrarTab("nv2_BNDJINTERC") ||
          this.mostrarTab("nv2_DTCCNCSD") ||
          this.mostrarTab("nv2_EMPAT") ||
          this.mostrarTab("nv2_NTEVLCN")
        );
      }

      if (tab === "nv1_TXR") {
        //Tx realizados
        return false;
      }

      if (tab === "nv1_TX") {
        //Tratamientos
        return (
          (this.$localStorageService.can("BT_Tratamientos") &&
            this.mostrarTab("nv2_HISSSNS")) ||
          this.mostrarTab("nv2_LAB") ||
          this.mostrarTab("nv2_TXIA")
        );
      }

      if (tab === "nv1_CT") {
        //Citas
        return (
          (this.$localStorageService.can("BT_Historial_citas") &&
            this.mostrarTab("nv2_HISCTS")) ||
          this.mostrarTab("nv2_HTRLRPLC") ||
          this.mostrarTab("nv2_HHJSBVND")
        );
      }

      if (tab === "nv1_RCB") {
        //Recibos
        return (
          (this.$localStorageService.can("BT_recibos") &&
            this.mostrarTab("nv2_RCB")) ||
          this.mostrarTab("nv2_HISPGS")
        );
      }

      if (tab === "nv1_RPLCS") {
        //Réplicas
        return (
          this.$localStorageService.can("BT_replicas_Px") &&
          this.mostrarTab("nv2_SLCTRPLC") &&
          this.mostrarTab("nv2_HTRPLC")
        );
      }

      if (tab === "nv1_QJS") {
        //Quejas
        return this.$localStorageService.can("Icono_01_quejas");
      }

      if (tab === "nv1_DFCS") {
        //Datos fiscales
        return this.$localStorageService.can("CA_03_fiscales");
      }

      if (tab === "BT_Cupones") {
        //Cuponera
        return this.$localStorageService.can("BT_Cupones");
      }

      ///////nivel 2

      if (tab === "nv2_AVPT") {
        //AVPTx
        return this.$localStorageService.can("BT_03_ver_avpt");
      }

      if (tab === "nv2_PHV3") {
        //Presupuesto histórico v3
        return this.$localStorageService.can("CA_03_presupuesto");
      }

      if (tab === "nv2_PHV4") {
        //Presupuesto histórico v4
        return this.$localStorageService.can("CA_03_presupuesto");
      }

      if (tab === "nv2_HistorialPTI") {
        //Historial PTI
        return this.$localStorageService.can("BT_Detalle_PTI");
      }
      if (tab === "nv2_DTPTIACT") {
        //Detalle PTI CDx
        return (
          this.$localStorageService.can("PT_01_pti_presuntivo") &&
          this.patInfo.idPtiActivo != null &&
          this.patInfo.idPtisinSDI == null
        );
      }

      if (tab === "nv2_RESPTI") {
        //Resúmen PTI
        return this.$localStorageService.can("CA_03_resumen_pti");
      }

      if (tab === "nv2_BJHS") {
        //Seguimiento de PTI
        return this.$localStorageService.can("BJ_historial_solicitudes");
      }

      if (tab === "nv2_HDXSDI") {
        //HDx
        return this.$localStorageService.can("HX_01_Hoja_de_hallazgos");
      }

      if (tab === "nv2_HDXSDIADUL") {
        //Solicitud PTI adulto
        return (
          this.$localStorageService.can("CA_03_solicitud_pti_adul") &&
          !this.blnClinicaDescentralizada &&
          this.sesionDia.herramientas &&
          this.patInfo.edadPaciente >= 12
        );
      }

      if (tab === "nv2_HDXSDININ") {
        //Solicitud PTI niño
        return (
          this.$localStorageService.can("CA_03_solicitud_pti_nino") &&
          !this.blnClinicaDescentralizada &&
          this.patInfo.edadPaciente <= 6
        );
      }

      if (tab === "nv2_HDXSDIMIX") {
        //Solicitud PTI mixto
        return (
          this.$localStorageService.can("CA_03_solicitud_pti_mix") &&
          !this.blnClinicaDescentralizada &&
          this.patInfo.edadPaciente >= 7 &&
          this.patInfo.edadPaciente < 12
        );
      }

      if (tab === "nv2_SPA") {
        //Solicitud PTI

        return (
          this.$localStorageService.can("CA_03_solicitud_pti_adul") &&
          this.blnClinicaDescentralizada === false &&
          this.sesionDia.herramientas
        );
      }
      if (tab === "nv2_SPTDSTZD") {
        //Solicitud PTI Descentralizado
        if (this.edad > 12) {
          return (
            this.$localStorageService.can("CA_03_solicitud_pti_desen") &&
            this.blnClinicaDescentralizada &&
            this.sesionDia.herramientas
          );
        } else {
          return (
            this.$localStorageService.can("CA_03_solicitud_pti_desen") &&
            this.blnClinicaDescentralizada
          );
        }
      }

      if (tab === "nv2_DETPTIOG") {
        //Detalle PTI OG
        return (
          this.$localStorageService.can("PT_01_pti_descentr_01") &&
          this.blnClinicaDescentralizada &&
          this.patInfo.idPtiActivo != null &&
          this.patInfo.idPtisinSDI == null
        );
      }

      if (tab === "nv2_IMPSNPTI") {
        //Impresión PTI
        return (
          this.$localStorageService.can("PR_01_imprimir_presen") &&
          this.patInfo.idPti !== null &&
          this.patInfo.ptiNuevoM2 === true
        );
      }
      if (tab === "nv2_VRSNIMPSNPTI") {
        //Consultas PTI
        return (
          this.$localStorageService.can("PR_01_consultar_vers_PTI") &&
          this.patInfo.idPti !== null &&
          this.patInfo.idPti !== undefined
        );
      }

      if (tab === "nv2_NTSPPTI") {
        //Notas PTI
        return (
          this.$localStorageService.can("Notas_01_M2") &&
          this.patInfo.idPti !== null &&
          this.patInfo.idPti !== undefined
        );
      }

      if (tab === "nv2_AJSTDGNSTC") {
        //Ajuste diagnóstico
        return (
          this.$localStorageService.can("AD_01_ajuste_dx") &&
          this.patInfo.idPti !== null &&
          this.patInfo.idPti !== undefined
        );
      }

      if (tab === "nv2_PTIALTR") {
        //PTI alto riesgo
        return this.$localStorageService.can("PTI_altoRiesgo_01");
      }

      if (tab === "nv2_HDXN") {
        //Hdx niño
        return (
          this.$localStorageService.can("CA_03_sol_nino_sinsdi") &&
          this.patInfo.edadPaciente <= 6
        );
      }

      if (tab === "nv2_HDXA") {
        //Hdx adulto
        return (
          this.$localStorageService.can("CA_03_sol_adul_sinsdi") &&
          !this.sesionDia.herramientas &&
          this.patInfo.edadPaciente >= 13
        );
      }

      if (tab === "nv2_HDXM") {
        //Hdx mixto
        return (
          this.$localStorageService.can("CA_03_sol_mixto_sinsdi") &&
          this.patInfo.edadPaciente >= 7 &&
          this.patInfo.edadPaciente <= 12
        );
      }

      if (tab === "nv2_PRES") {
        //Presupuesto
        return this.$localStorageService.can("CA_03_presup_nosdi");
      }

      if (tab === "nv2_HDXSDI") {
        //ECE
        return this.$localStorageService.can("ECE_01_principal");
      }

      if (tab === "nv2_HTRCN") {
        //Historiales clinicos
        return this.$localStorageService.can("BT_ECE_HisticialClinico");
      }

      if (tab === "nv2_HTRCA") {
        //Hc adulto
        return this.$localStorageService.can("CA_03_historia_clinica");
      }

      if (tab === "nv2_HTRCE") {
        //HC emergencia
        return this.$localStorageService.can("CA_03_hist_clin_urg");
      }

      if (tab === "nv2_HRRDAG") {
        //Herramientas de diagnóstico
        return this.$localStorageService.can("CA_03_herram_dx");
      }

      if (tab === "nv2_CNSNTMTS") {
        //Consentimientos
        return (
          this.$localStorageService.can("Con_01_consentimiento") &&
          this.verConsentimientos != null
        );
      }

      if (tab === "nv2_BNDJINTERC") {
        //Interconsulta
        return this.$localStorageService.can("IC_01_intercosulta");
      }

      if (tab === "nv2_DTCCNCSD") {
        //Detección de necesidades
        return this.$localStorageService.can("CA_03_detect_necesidades");
      }

      if (tab === "nv2_EMPAT") {
        //Mapa de empatía
        return this.$localStorageService.can("CA_08_empatia");
      }

      if (tab === "nv2_NTEVLCN") {
        //>Nota de evolución
        return this.$localStorageService.can("NE_01_nota_evoluc");
      }

      if (tab === "nv2_HISCTS") {
        //Historial de citas
        return this.$localStorageService.can("CT_01_consu_citas");
      }

      if (tab === "nv2_HTRLRPLC") {
        //Recetas
        return this.$localStorageService.can("Receta_01");
      }

      if (tab === "nv2_HHJSBVND") {
        //Historial de Hojas de Bienvenida
        return this.$localStorageService.can("Historial_HJBienveni_01");
      }

      if (tab === "nv2_TXP") {
        //Tx programados
        return this.$localStorageService.can("CA_03_tx_programados");
      }

      if (tab === "nv2_HISSSNS") {
        //Sesiones realizadas
        return this.$localStorageService.can("CA_03_sesiones");
      }


      if (tab === "nv2_LAB") {
        //Laboratorio
        return this.$localStorageService.can("BT_odt_lab");
      }

      if (tab === "nv2_TXIA") {
        //Tx activar / inactivar
        return this.$localStorageService.can("Tx_01_activo_inactivo");
      }

      if (tab === "nv2_RCB") {
        //Recibos
        return this.$localStorageService.can("CA_03_documentos");
      }

      if (tab === "nv2_HISPGS") {
        //Estado de Cuenta
        return false;
        /*return this.patInfo.idPti !== null &&
              this.patInfo.idPti !== undefined;*/
      }

      if (tab === "nv2_SLCTRPLC") {
        //Solicitud de réplica
        return this.$localStorageService.can("CA_03_solic_rep");
      }

      if (tab === "nv2_HTRPLC") {
        //Historial de réplicas
        return this.$localStorageService.can("CA_03_historia_rep");
      }

      if (tab === "nv2_DIAGINICIAL") {
        //Diagnostico inicial OG
        return this.$localStorageService.can("BT_Diagnostico_inicial");
      }

      console.error("--------------PERMISO NO ENCONTRADO: " + tab);
      return false;
    },

    obtenerMedidaPantalla() {
      this.windowWidth = window.innerWidth;
    },
    async validacionActivaHerramientasHdx() {
      return await this.$http.get(
        this.$api + "rutaExpediente/validacionActivaHdx"
      );
    },
    async vadicionActivarEceClinica() {
      const parametros = { idClinica: this.idClinica };
      return await this.$http.post(
        this.$api + "catalogos/obtenerClinicasActivasECE",
        parametros
      );
    },
    descargar(nombre, datos) {
      const byteCharacters = atob(datos);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement("a");
      link.href = url;
      link.download = nombre;
      link.click();
    },
    showMsgBoxOne() {
      const titleNodes = this.$createElement("div", {
        domProps: { innerHTML: "<b>Alerta</b>" },
      });
      const messageNodes = this.$createElement("div", {
        domProps: {
          innerHTML:
            '<div class="divModalF"><b>Desea continuar con la operación?</b>' +
            "<br></div>",
        },
      });
      this.$bvModal.msgBoxConfirm([messageNodes], {
        title: [titleNodes],
        size: "sm",
        footerClass: "p-2",
        hideHeaderClose: false,
        centered: true,
        buttonSize: "sm",
        okTitle: "Cerrar",
      });
    },

    llenarListaClinicas() {
      this.$http.get(this.$api + "catalogos/listaClinicas").then((response) => {
        this.clinicas = response.data.data;
      });
    },

    llenarListaPadecimientos() {
      var url = "catalogos/listaPadecimientosOd";

      this.$http.get(this.$api + url).then((response) => {
        this.padecimientosAdulto = response.data.data;
        this.padecimientosNino = response.data.data;
        this.padecimientosMixto = response.data.data;
      });
    },

    llenarListaDoctores() {
      const parametros = {
        idClinica: this.idClinica,
      };
      this.$http
        .post(
          this.$api + "diagnostico/hoja/listaDoctoresClinicaAgendaDoc",
          parametros
        )
        .then((response) => {
          this.doctores = response.data.data;
        });
    },

    obtenerPlanesConvenios() {
      this.loaderPlanes = true;
      const params = { idPaciente: this.idPaciente };
      this.$http
        .post(this.$api + "paciente/estadoPlanesPaciente", params)
        .then((resp) => {
          this.planesConvenios = resp.data.data;
          this.planesActivos = this.planesConvenios.filter(
            (plan) => plan.planActivo === true
          );
          this.planesInactivos = this.planesConvenios.filter(
            (plan) => plan.planActivo === false
          );          
          this.loaderPlanes = false;
        })
        .catch((error) => {
          console.error(error);
          this.loaderPlanes = false;
        })
        .finally(() => {
          this.loaderPlanes = false;
        });
    },

    obtenerPrecaucionesMedicasPaciente() {
      this.loaderPrecMed = true;
      const params = { idPaciente: this.idPaciente };
      this.$http
        .post(this.$api + "paciente/obtenerPrecaucionesMedicas", params)
        .then((resp) => {
          this.precaucionesMedicas = resp.data.data;
          this.loaderPrecMed = false;
        })
        .catch((error) => {
          console.error(error);
          this.loaderPrecMed = false;
        })
        .finally(() => {
          this.loaderPrecMed = false;
        });
    },

    llenarListaDetallePaciente() {
      this.loading = true;
      this.loadingSesion = true;
      this.token = this.$session.get("token");
      const params = {
        idPaciente: this.idPaciente,
        vieneDePerfilPx: true
      };
      this.$http
        .post(this.$api + "paciente/perfiles/obtenerDetallePaciente", params)
        .then((response) => {
          if (response.status === 200) {
            response.data.data.fechaNacimiento = moment(
              response.data.data.fechaNacimiento
            )
              .utc()
              .format("DD/MM/YYYY");
            this.edad = response.data.data.edadPaciente;
            this.patInfo = response.data.data;
            
            if (
              this.patInfo.idPti !== undefined &&
              this.patInfo.idPti !== null
            ) {
              this.patInfo.idPti = this.patInfo.idPti.toString();
              //  this.traerNivelSalud();
              this.traerOpcionPTI();
            }

            if (
              this.patInfo.idPtisinSDI !== undefined &&
              this.patInfo.idPtisinSDI !== null
            ) {
              this.patInfo.idPtisinSDI = this.patInfo.idPtisinSDI.toString();
            }

            if (
              this.patInfo.ptisActivos != null &&
              this.patInfo.ptisActivos.length != 0
            ) {
              var ptiReciente = this.patInfo.ptisActivos.sort(
                (a, b) =>
                  new Date(b.fechaModificacion).getTime() -
                  new Date(a.fechaModificacion).getTime()
              )[0];
              this.patInfo.idPtiActivo = ptiReciente["idPti"];
              this.estatusSolicitud =
                this.patInfo.ptisActivos[0].estatusSolicitud;
            }
          }
        })
        .catch()
        .finally(() => {
          this.loading = false;
          this.loadingSesion = false;

          this.obtenerPlanesConvenios();
          this.obtenerPrecaucionesMedicasPaciente();
          
        });
    },

    traerSesionActiva() {
      const i = new Date();
      i.setDate(i.getDate());
      i.setHours(0, 0, 0, 0);
      const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const f = new Date();
      f.setHours(23, 59, 59, 999);
      const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const url = this.$api + "sesion/dia";
      const parametros = {
        idPaciente: this.idPaciente,
        idClinica: this.idClinica,
        horaInicio: inicio,
        horaFin: fin,
      };

      this.sesionDia = {
        herramientas: false,
      };

      this.$http.post(url, parametros).then((response) => {
        if (response.data.data) {
          if (
            this.idSesionSeleccionada !== undefined &&
            this.idSesionSeleccionada !== null
          ) {
            const sesionEncontrada = response.data.data.find(
              (it) => Number(it.idSesion) === Number(this.idSesionSeleccionada)
            );

            if (sesionEncontrada !== undefined) {
              this.sesionDia = sesionEncontrada;
            }
          } else {
            if (response.data.data[0] !== undefined) {
              this.sesionDia = response.data.data[0];
            }
          }
        }
      });
    },

    /* traerNivelSalud() {
        const parametros = {idPti: this.patInfo.idPti}
        const urlNivelSalud =
          this.$api + "diagnostico/obtener/nivelSalud";
  
        this.$http
          .post(urlNivelSalud, parametros)
          .then((response) => {
            if (response.data.data) {
              this.nivelSalud.push(response.data.data.actual);
              this.nivelSalud.push(response.data.data.sinContratar);
              this.nivelSalud.push(response.data.data.restante);
            }
          })
          .catch((error) => {
            this.showErrorNivelSalud(error);
          });
      },*/
    traerOpcionPTI() {
      const parametros = { idPti: this.patInfo.idPti };
      const url = this.$api + "diagnostico/opcion";
      this.$http.post(url, parametros).then((response) => {
        if (response.data.data) {
          this.opcionSel = response.data.data;
        }
      });
    },

    onTabSelected() {
      this.loadingSesion = true;
      this.sesionIniciada = false;
      const params = {
        idPaciente: this.idPaciente,
      };
      this.$http
        .post(this.$api + "sesion/empleadoTieneSesionActivaPaciente", params)
        .then((response) => {
          this.sesionIniciada = response.data.data;
        })
        .finally(() => {
          this.loadingSesion = false;
        });
    },
    showModal(plan) {
      this.loading = true;
      this.detallePlanSeleccionado = plan;
      const idPlan = plan.idPlan;
      const parametros = { idPlan: parseInt(idPlan, 10) };
      this.$http
        .post(this.$api + "empresas/detallePlan", parametros)
        .then((response) => {
          if (response.data.data) {
            this.planInfo = response.data.data;
            this.planInfo.idPlan = this.planInfo.idPlan.toString();
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          this.$refs["planDetalle"].show()
    });
    },
    hideModal() {
      this.$refs["planDetalle"].hide();
    },

    obtenerParentescoDelPaciente() {
      const params = {
        idPaciente: this.idPaciente,
      };
      this.$http
        .post(this.$api + "paciente/perfiles/obtenerParentescoPaciente", params)
        .then((response) => {
          if (response.data.data) {
            this.parentesco = response.data.data;
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    showModalhistorialPlanesConvenios() {
      this.$refs["historialPlanesConvenios"].show();
    },
    hideModalhistorialPlanesConvenios() {
      this.$refs["historialPlanesConvenios"].hide();
    },
    obtenerClinicaTieneDesentralizado() {
      const parametros = { idClinica: this.idClinica };
      this.$http
        .post(this.$api + "catalogos/obtenerClinicaDesentralizado", parametros)
        .then((response) => {
          this.blnClinicaDescentralizada = response.data.data;
        });
    },

    mostrarPacientesRelacionados() {
      this.mostrarModalPacientesRelacionados = false;
      this.pacientesRelacionados = null;
      this.$http
        .get(
          this.$api +
            "paciente/perfiles/obtenerParentezcosPaciente?idPaciente=" +
            this.idPaciente
        )
        .then((response) => {
          this.pacientesRelacionados = response.data.data;
        })
        .finally(() => (this.mostrarModalPacientesRelacionados = true));
    },

    existePtiRechazado() {
      const params = {
        idPaciente: this.idPaciente,
      };
      this.$http
        .post(this.$api + "pti/existePtiDesentralRechazado", params)
        .then((response) => {
          this.existeRechazoDesentralizado =
            response.data.data.existePtiRechazo;
          this.idPtiRechazo = response.data.data.idPTI;
          this.etapaRechazo = response.data.data.etapa;
          this.solicitudRechazo = response.data.data.idSolicitud;
          this.vecesRechazo = response.data.data.vecesRechazo;

          if (this.existeRechazoDesentralizado) {
            this.sesionDia = {
              herramientas: true,
            };
          }
        })
        .catch((error) => {
          console.error(
            "Error al obtener la validación de existencia rechazo de un pti del  del paciente: " +
              error
          );
        }).finally(() =>{
          
        });
    },

    ptiCreado() {
      this.existeRechazoDesentralizado = false;
    },

    cambiarBloqueoSinSDI(bloqueo) {
      this.bloquedoSinSDI = bloqueo;
    },
    /*cambiarBloqueoEdicionPTI(bloqueo) {
        this.bloquedoEditarPTI = bloqueo;
      },*/

    marcarPacienteVIP(){
      const params = {
        idPaciente: this.idPaciente,
      };
      this.$http
          .post(this.$api + "paciente/perfiles/asignarVipPaciente", params)
          .then(() => {
            if (this.patInfo.esPacienteVIP){
              this.$swal(
                  "EXITO",
                  "EL PACIENTE HA SIDO DESASIGNADO COMO MISD",
                  "success"
              );
            }else{
              this.$swal(
                  "ÉXITO",
                  "EL PACIENTE HA SIDO ASIGNADO COMO MISD",
                  "success"
              );
            }

          })
          .catch((error) => {
            console.error(
                "Error al obtener la validación de existencia rechazo de un pti del  del paciente: " +
                error
            );
            this.$swal(
                "ERROR",
                "HUBO UN ERROR EN LA SOLICITUD. POR FAVOR, INTÉNTALO DE NUEVO.",
                "error"
            );
          }).finally(() =>{
            this.llenarListaDetallePaciente();
      });
    }
  },
};
</script>

<style scoped>
p {
  margin: 0px;
  font-size: 0.9em;
  color: #4b4b4b;
}

.borde-derecho {
  border-right: 1px solid #AFD9E9;
  height: 65%;
  position: absolute;
  top: 10%;
  right: 0;
}

.txt_info{
  font-weight: 600;
}

.selected-tab {
  font-weight: 600;
  color: #464646;

  font-size: 0.95em;
}

.seleccionable{
  cursor: pointer;
}

.default-tab {
  text-align: center;
  font-size: 0.95em;
  margin-bottom: 1px;
}

.default-color{
  color: #888888 !important;
}

.selected-subtab {
  border: 1px solid #006aaa;
  border-radius: 10px;
  font-weight: 500;
  color: #575757;
  padding: 8px 20px;
  display: inline-block;
  width: max-content;
  white-space: nowrap;
  font-size: 0.9em;
}

.default-subtab {
  background-color: #eeeeee;
  color: #979797 !important;
  padding: 8px 20px;
  display: inline-block;
  width: max-content;
  white-space: nowrap;
  text-align: center;
  font-size: 0.9em;
}

.selected-subtab,
.default-subtab {
  display: inline-block;
  white-space: nowrap;
  font-size: 0.9em;
  text-align: center;
}

.default-subtab,
.default-tab {
  cursor: pointer;
}

.default-subtab:hover {
  background-color: #f7f7f7;
  font-weight: 500;
}

.default-tab:hover {
  font-weight: 500;
  color: #006aaa;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.close_x_gray:hover{
  filter: brightness(0) saturate(100%) invert(49%) sepia(0%) saturate(1%) hue-rotate(165deg) brightness(99%) contrast(87%);
}

.bordeActivo{
  border: 1px solid #2bba2b;
}

.acciones:hover{
  color: #2375ac;
  cursor: pointer;
}

.label-txt{
  font-size: .75em
}

.columna-img-px {
  flex-basis: 10%;
  max-width: 10%;
}
.columna-info-paciente {
  flex-basis: 26%;
  max-width: 26%;
}

.columna-dinero {
  flex-basis: 17%;
  max-width: 17%;
}

.columna-patient-journey {
  flex-basis: 47%;
  max-width: 47%;
}

.button {
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #ddd;
  margin-right: 10px;
  border: none;
  outline: none;
  cursor: pointer;
}

.button.selected {
  background-color: #61a1c9;
}

.colorIcons {
  color: rgb(54, 54, 54);
}

.button.selected .colorIcons {
  color: #fff;
}

.button:not(.selected) .colorIcons {
  color: #ccc;
}

.button.selected:focus {
  box-shadow: 0 0 0 1px #fff, 0 0 0 2px #61a1c9;
}

.colorIcons {
  color: #61a1c9;
}

.tabHover:hover {
  color: red;
}
/*  .tab-content >  .tab-pane {
  
  border-left: 1px solid #dee2e6  !important;
  border-right: 1px solid #dee2e6 !important;
  border-bottom: 1px solid #dee2e6 !important;
  } */

.cardPrincipal .card-body {
  padding: 0rem 1.25rem 1.25rem 1.25rem;
}

.rowDatoPaciente {
  text-align: left;
}

.rowDatoPaciente {
  text-align: left;
  font-size: 14px;
}

.nombreCompletoPaciente {
  font-size: 18px !important;
  font-weight: bold;
  color: #17a2b8;
}

.titulo-tab {
  font-weight: bold;
  font-size: 14px;
}

.titulo-idPaciente {
  font-weight: bold;
}

.iconoDecoracion {
  width: 6%;
}

.iconoDecoracionRegular {
  width: 3.8%;
}

.botonPaciente {
  width: 28px;
  cursor: pointer;
  display: inline-block;
}

.botonPaciente:hover {
  width: 30px;
  cursor: pointer;
}

.tituloCajaDetallePaciente {
  text-align: center;
  color: var(--color-dentalia);
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
}
.ocultarCajaDetallePaciente {
  float: right;
  margin-top: -20px;
}

.grid-contenido-central {
  float: left;
  width: 100%;
  padding: 1%;
}
</style>
